export default function Events() {
    return (
      <div className="container" id="events">
        <div className="row eve">
          <div className="col">
            <h1>Events</h1>
            <p>
            We periodically organize many events through which we aim to increase the bonding of the entire student community, and inculcate in them, a sense of togetherness. We also aim to increase the interactions of the faculty with the students outside the classrooms.
            </p>
          </div>
        </div>
      </div>
    );
  }